<div [id]="'chart-container'+id" [ngStyle]="{ height: popUp ? '28em' : 'calc(100% - 3rem)' }"></div>
